import { render } from "./Inspe.vue?vue&type=template&id=2fdb46e6&scoped=true"
import script from "./Inspe.vue?vue&type=script&lang=js"
export * from "./Inspe.vue?vue&type=script&lang=js"

import "./Inspe.vue?vue&type=style&index=0&id=2fdb46e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdb46e6"]])

export default __exports__